<template>
	<v-app>
		<div id="app">
			<link
				href="https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap"
				rel="stylesheet"
			/>
			<link rel="preconnect" crossorigin href="https://lens-advisors-api.s3.amazonaws.com" />
			<link rel="preconnect" href="https://api.lensadvisors.com" />
			<AlertComponent />
			<router-view></router-view>
		</div>
	</v-app>
</template>

<script>
import "material-design-icons-iconfont/dist/material-design-icons.css";
import AlertComponent from "@/components/AlertComponent";

export default {
	name: "app",
	metaInfo() { 
		return {
			title:
				"LensAdvisors - Compare prices among the leading contact lens suppliers",
			meta: [
				{
					name: "description",
					content: "Compare prices among the leading contact lens suppliers",
					vmid: "description"
				},
				{
					property: "og:title",
					content: "LensAdvisors - Compare prices among the leading contact lens suppliers",
					vmid: "og:title"
				},
				{
					property: "og:description",
					content: "Compare prices among the leading contact lens suppliers",
					vmid: "og:description"
				},
				{
					property: "og:image",
					content: `https://www.lensadvisors.com${require('@/assets/LensAdvisors.jpg')}`,
					vmid: "og:image",
				},
				{
					property: "og:image:width",
					content: "1060",
					vmid: "og:image:width"
				},
				{
					property: "og:image:height",
					content: "203",
					vmid: "og:image:height"
				},
				{
					vmid: "og:site_name",
					property: "og:site_name",
					content: "LensAdvisors"
				}
			]
		}
	},
	data: function() {
		return {
			message: "String"
		};
	},
	components: {
		AlertComponent
	}
};
</script>

<style lang="scss">
	html, body {
		font-family: "Roboto", sans-serif;
		font-size: 12px !important;
	}

	@media screen and (max-width: 1200px) {
		html, body {
			font-size: 10px !important;
		}
	}
</style>
